/** Mirrors crm LeadSource / LeadStatus. */
export const LEAD_SOURCES = [
  { value: 'upwork', label: 'Upwork' },
  { value: 'linkedin', label: 'LinkedIn' },
  { value: 'website', label: 'Website' },
  { value: 'referral', label: 'Referral' },
  { value: 'outbound', label: 'Outbound' },
  { value: 'fiverr', label: 'Fiverr' },
  { value: 'rfp', label: 'RFP / tender' },
  { value: 'other', label: 'Other' },
] as const;

export type LeadSource = (typeof LEAD_SOURCES)[number]['value'];

export const LEAD_STATUSES = [
  { value: 'new', label: 'New' },
  { value: 'qualified', label: 'Qualified' },
  { value: 'disqualified', label: 'Disqualified' },
  { value: 'converted', label: 'Converted' },
] as const;

export type LeadStatus = (typeof LEAD_STATUSES)[number]['value'];

/** Mirrors crm IcpFit (ADR-108); '' = not assessed yet. */
export const ICP_FITS = [
  { value: 'fits', label: 'Fits' },
  { value: 'partial', label: 'Partial' },
  { value: 'no_fit', label: 'No fit' },
] as const;

export type IcpFit = (typeof ICP_FITS)[number]['value'];

export const icpFitLabel = (v: string): string =>
  ICP_FITS.find((x) => x.value === v)?.label ?? 'Not assessed';

export function icpFitVariant(v: string): 'default' | 'secondary' | 'destructive' | 'outline' {
  if (v === 'fits') return 'default';
  if (v === 'partial') return 'secondary';
  if (v === 'no_fit') return 'destructive';
  return 'outline';
}

export const sourceLabel = (s: string): string =>
  LEAD_SOURCES.find((x) => x.value === s)?.label ?? s;

export const statusLabel = (s: string): string =>
  LEAD_STATUSES.find((x) => x.value === s)?.label ?? s;

export function statusVariant(s: string): 'default' | 'secondary' | 'destructive' | 'outline' {
  if (s === 'converted') return 'default';
  if (s === 'disqualified') return 'destructive';
  if (s === 'qualified') return 'secondary';
  return 'outline'; // new
}
